import { render } from "./DocumentsNavigation.vue?vue&type=template&id=58b61c2b&scoped=true"
import script from "./DocumentsNavigation.vue?vue&type=script&lang=js"
export * from "./DocumentsNavigation.vue?vue&type=script&lang=js"

import "./DocumentsNavigation.vue?vue&type=style&index=0&id=58b61c2b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b61c2b"]])

export default __exports__